import { observer } from 'mobx-react-lite';
import TableComponent from './TableComponent';
import { useStore } from '../../../app/stores/store';
import UnauthorizedMessage from '../../UnauthorizedMessage';
import LoadingComponent from '../../../app/layout/LoadingComponent';

function EmployeeDetailsReport() {
  const { RestorationStore, dashboardStore, commonStore } = useStore();
  const dateBasedApiCall = async () => {
    await RestorationStore.HandelAllEmployeeDetails();
  };
  return (
    <div>
      {dashboardStore.dashboard.loadingdata === 'loading' && (
        <div style={{ marginTop: '30px' }}>
          <LoadingComponent />
        </div>
      )}
      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        !commonStore.filterModeOne?.includes('EDP01') && (
          <UnauthorizedMessage />
        )}
      {commonStore.filterModeOne?.includes('EDP01') && (
        <TableComponent
          name={'Employee Details Report'}
          dateBasedApiCall={dateBasedApiCall}
          DateInput={false}
          DualInut={false}
          downloadName={'EmployeeDetailsReport'}
        />
      )}
    </div>
  );
}
export default observer(EmployeeDetailsReport);
